import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  PLAY_TOURNAMENT_FEATURE_KEY,
  PlayTournamentState,
} from './play-tournament.reducer';

// Lookup the 'PlayTournament' feature state managed by NgRx
export const getPlayTournamentState =
  createFeatureSelector<PlayTournamentState>(PLAY_TOURNAMENT_FEATURE_KEY);

export const getPlayTournamentLoaded = createSelector(
  getPlayTournamentState,
  (state: PlayTournamentState) => state.loaded,
);

export const getPlayTournamentError = createSelector(
  getPlayTournamentState,
  (state: PlayTournamentState) => state.error,
);

export const getSelectedId = createSelector(
  getPlayTournamentState,
  (state: PlayTournamentState) => state.selectedId,
);

export const getIsPlayStarting = createSelector(
  getPlayTournamentState,
  (state: PlayTournamentState) => state.startingPlay,
);
